/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AutorizarRouteImport } from './routes/autorizar'
import { Route as ConectarRouteImport } from './routes/conectar'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as OwnerRouteImport } from './routes/owner'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as DesktopConnectorRouteImport } from './routes/desktop.connector'
import { Route as DesktopHandoverRouteImport } from './routes/desktop.handover'
import { Route as DesktopSignInRouteImport } from './routes/desktop.sign-in'
import { Route as DesktopSignedInRouteImport } from './routes/desktop.signed-in'
import { Route as DevGalleryRouteImport } from './routes/dev.gallery'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as OrgOrgIdRouteImport } from './routes/org.$orgId'
import { Route as OrgOrgIdIndexRouteImport } from './routes/org.$orgId.index'
import { Route as OrgOrgIdApprovalsRouteImport } from './routes/org.$orgId.approvals'
import { Route as OrgOrgIdCalendarRouteImport } from './routes/org.$orgId.calendar'
import { Route as OrgOrgIdDriveRouteImport } from './routes/org.$orgId.drive'
import { Route as OrgOrgIdForumRouteImport } from './routes/org.$orgId.forum'
import { Route as OrgOrgIdHomeRouteImport } from './routes/org.$orgId.home'
import { Route as OrgOrgIdMembersRouteImport } from './routes/org.$orgId.members'
import { Route as OrgOrgIdNotificationsRouteImport } from './routes/org.$orgId.notifications'
import { Route as OrgOrgIdOnboardingRouteImport } from './routes/org.$orgId.onboarding'
import { Route as OrgOrgIdProposalsRouteImport } from './routes/org.$orgId.proposals'
import { Route as OrgOrgIdRoutinesRouteImport } from './routes/org.$orgId.routines'
import { Route as OrgOrgIdSearchRouteImport } from './routes/org.$orgId.search'
import { Route as OrgOrgIdSettingsRouteImport } from './routes/org.$orgId.settings'
import { Route as OrgOrgIdTaskManagerRouteImport } from './routes/org.$orgId.task-manager'
import { Route as OrgOrgIdTeamRouteImport } from './routes/org.$orgId.team'
import { Route as OrgOrgIdWikiRouteImport } from './routes/org.$orgId.wiki'
import { Route as OrgOrgIdAgentsNewRouteImport } from './routes/org.$orgId.agents.new'
import { Route as OrgOrgIdCChannelIdRouteImport } from './routes/org.$orgId.c.$channelId'
import { Route as OrgOrgIdForumTopicIdRouteImport } from './routes/org.$orgId.forum_.$topicId'
import { Route as OrgOrgIdIssuesIndexRouteImport } from './routes/org.$orgId.issues.index'
import { Route as OrgOrgIdIssuesNumberRouteImport } from './routes/org.$orgId.issues.$number'
import { Route as OrgOrgIdSettingsSectionRouteImport } from './routes/org.$orgId.settings_.$section'
import { Route as OrgOrgIdThreadsIndexRouteImport } from './routes/org.$orgId.threads.index'
import { Route as OrgOrgIdThreadsThreadIdRouteImport } from './routes/org.$orgId.threads.$threadId'
import { Route as OrgOrgIdWikiSlugRouteImport } from './routes/org.$orgId.wiki_.$slug'
import { Route as OrgOrgIdAgentsAgentIdIndexRouteImport } from './routes/org.$orgId.agents.$agentId.index'
import { Route as OrgOrgIdAgentsAgentIdMemoryRouteImport } from './routes/org.$orgId.agents.$agentId.memory'
import { Route as OrgOrgIdDmAgentAgentIdRouteImport } from './routes/org.$orgId.dm.agent.$agentId'
import { Route as OrgOrgIdDmPersonUserIdRouteImport } from './routes/org.$orgId.dm.person.$userId'
import { Route as OrgOrgIdSettingsComputersMachineIdRouteImport } from './routes/org.$orgId.settings_.computers.$machineId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutorizarRoute = AutorizarRouteImport.update({
  id: '/autorizar',
  path: '/autorizar',
  getParentRoute: () => rootRouteImport,
} as any)
const ConectarRoute = ConectarRouteImport.update({
  id: '/conectar',
  path: '/conectar',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const OwnerRoute = OwnerRouteImport.update({
  id: '/owner',
  path: '/owner',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: '/privacidade',
  path: '/privacidade',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermosRoute = TermosRouteImport.update({
  id: '/termos',
  path: '/termos',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopConnectorRoute = DesktopConnectorRouteImport.update({
  id: '/desktop/connector',
  path: '/desktop/connector',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopHandoverRoute = DesktopHandoverRouteImport.update({
  id: '/desktop/handover',
  path: '/desktop/handover',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopSignInRoute = DesktopSignInRouteImport.update({
  id: '/desktop/sign-in',
  path: '/desktop/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopSignedInRoute = DesktopSignedInRouteImport.update({
  id: '/desktop/signed-in',
  path: '/desktop/signed-in',
  getParentRoute: () => rootRouteImport,
} as any)
const DevGalleryRoute = DevGalleryRouteImport.update({
  id: '/dev/gallery',
  path: '/dev/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdRoute = OrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgOrgIdIndexRoute = OrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdApprovalsRoute = OrgOrgIdApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdCalendarRoute = OrgOrgIdCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdDriveRoute = OrgOrgIdDriveRouteImport.update({
  id: '/drive',
  path: '/drive',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdForumRoute = OrgOrgIdForumRouteImport.update({
  id: '/forum',
  path: '/forum',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdHomeRoute = OrgOrgIdHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdMembersRoute = OrgOrgIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdNotificationsRoute = OrgOrgIdNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdOnboardingRoute = OrgOrgIdOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdProposalsRoute = OrgOrgIdProposalsRouteImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdRoutinesRoute = OrgOrgIdRoutinesRouteImport.update({
  id: '/routines',
  path: '/routines',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdSearchRoute = OrgOrgIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdSettingsRoute = OrgOrgIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdTaskManagerRoute = OrgOrgIdTaskManagerRouteImport.update({
  id: '/task-manager',
  path: '/task-manager',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdTeamRoute = OrgOrgIdTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdWikiRoute = OrgOrgIdWikiRouteImport.update({
  id: '/wiki',
  path: '/wiki',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdAgentsNewRoute = OrgOrgIdAgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdCChannelIdRoute = OrgOrgIdCChannelIdRouteImport.update({
  id: '/c/$channelId',
  path: '/c/$channelId',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdForumTopicIdRoute = OrgOrgIdForumTopicIdRouteImport.update({
  id: '/forum_/$topicId',
  path: '/forum/$topicId',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdIssuesIndexRoute = OrgOrgIdIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdIssuesNumberRoute = OrgOrgIdIssuesNumberRouteImport.update({
  id: '/issues/$number',
  path: '/issues/$number',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdSettingsSectionRoute = OrgOrgIdSettingsSectionRouteImport.update({
  id: '/settings_/$section',
  path: '/settings/$section',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdThreadsIndexRoute = OrgOrgIdThreadsIndexRouteImport.update({
  id: '/threads/',
  path: '/threads/',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdThreadsThreadIdRoute = OrgOrgIdThreadsThreadIdRouteImport.update({
  id: '/threads/$threadId',
  path: '/threads/$threadId',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdWikiSlugRoute = OrgOrgIdWikiSlugRouteImport.update({
  id: '/wiki_/$slug',
  path: '/wiki/$slug',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdAgentsAgentIdIndexRoute =
  OrgOrgIdAgentsAgentIdIndexRouteImport.update({
    id: '/agents/$agentId/',
    path: '/agents/$agentId/',
    getParentRoute: () => OrgOrgIdRoute,
  } as any)
const OrgOrgIdAgentsAgentIdMemoryRoute =
  OrgOrgIdAgentsAgentIdMemoryRouteImport.update({
    id: '/agents/$agentId/memory',
    path: '/agents/$agentId/memory',
    getParentRoute: () => OrgOrgIdRoute,
  } as any)
const OrgOrgIdDmAgentAgentIdRoute = OrgOrgIdDmAgentAgentIdRouteImport.update({
  id: '/dm/agent/$agentId',
  path: '/dm/agent/$agentId',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdDmPersonUserIdRoute = OrgOrgIdDmPersonUserIdRouteImport.update({
  id: '/dm/person/$userId',
  path: '/dm/person/$userId',
  getParentRoute: () => OrgOrgIdRoute,
} as any)
const OrgOrgIdSettingsComputersMachineIdRoute =
  OrgOrgIdSettingsComputersMachineIdRouteImport.update({
    id: '/settings_/computers/$machineId',
    path: '/settings/computers/$machineId',
    getParentRoute: () => OrgOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/autorizar': typeof AutorizarRoute
  '/conectar': typeof ConectarRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/owner': typeof OwnerRoute
  '/privacidade': typeof PrivacidadeRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/termos': typeof TermosRoute
  '/terms': typeof TermsRoute
  '/desktop/connector': typeof DesktopConnectorRoute
  '/desktop/handover': typeof DesktopHandoverRoute
  '/desktop/sign-in': typeof DesktopSignInRoute
  '/desktop/signed-in': typeof DesktopSignedInRoute
  '/dev/gallery': typeof DevGalleryRoute
  '/invite/$token': typeof InviteTokenRoute
  '/org/$orgId': typeof OrgOrgIdRouteWithChildren
  '/org/$orgId/approvals': typeof OrgOrgIdApprovalsRoute
  '/org/$orgId/calendar': typeof OrgOrgIdCalendarRoute
  '/org/$orgId/drive': typeof OrgOrgIdDriveRoute
  '/org/$orgId/forum': typeof OrgOrgIdForumRoute
  '/org/$orgId/home': typeof OrgOrgIdHomeRoute
  '/org/$orgId/members': typeof OrgOrgIdMembersRoute
  '/org/$orgId/notifications': typeof OrgOrgIdNotificationsRoute
  '/org/$orgId/onboarding': typeof OrgOrgIdOnboardingRoute
  '/org/$orgId/proposals': typeof OrgOrgIdProposalsRoute
  '/org/$orgId/routines': typeof OrgOrgIdRoutinesRoute
  '/org/$orgId/search': typeof OrgOrgIdSearchRoute
  '/org/$orgId/settings': typeof OrgOrgIdSettingsRoute
  '/org/$orgId/task-manager': typeof OrgOrgIdTaskManagerRoute
  '/org/$orgId/team': typeof OrgOrgIdTeamRoute
  '/org/$orgId/wiki': typeof OrgOrgIdWikiRoute
  '/org/$orgId/': typeof OrgOrgIdIndexRoute
  '/org/$orgId/agents/new': typeof OrgOrgIdAgentsNewRoute
  '/org/$orgId/c/$channelId': typeof OrgOrgIdCChannelIdRoute
  '/org/$orgId/forum/$topicId': typeof OrgOrgIdForumTopicIdRoute
  '/org/$orgId/issues/$number': typeof OrgOrgIdIssuesNumberRoute
  '/org/$orgId/settings/$section': typeof OrgOrgIdSettingsSectionRoute
  '/org/$orgId/threads/$threadId': typeof OrgOrgIdThreadsThreadIdRoute
  '/org/$orgId/wiki/$slug': typeof OrgOrgIdWikiSlugRoute
  '/org/$orgId/issues/': typeof OrgOrgIdIssuesIndexRoute
  '/org/$orgId/threads/': typeof OrgOrgIdThreadsIndexRoute
  '/org/$orgId/agents/$agentId/memory': typeof OrgOrgIdAgentsAgentIdMemoryRoute
  '/org/$orgId/dm/agent/$agentId': typeof OrgOrgIdDmAgentAgentIdRoute
  '/org/$orgId/dm/person/$userId': typeof OrgOrgIdDmPersonUserIdRoute
  '/org/$orgId/settings/computers/$machineId': typeof OrgOrgIdSettingsComputersMachineIdRoute
  '/org/$orgId/agents/$agentId/': typeof OrgOrgIdAgentsAgentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/autorizar': typeof AutorizarRoute
  '/conectar': typeof ConectarRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/owner': typeof OwnerRoute
  '/privacidade': typeof PrivacidadeRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/termos': typeof TermosRoute
  '/terms': typeof TermsRoute
  '/desktop/connector': typeof DesktopConnectorRoute
  '/desktop/handover': typeof DesktopHandoverRoute
  '/desktop/sign-in': typeof DesktopSignInRoute
  '/desktop/signed-in': typeof DesktopSignedInRoute
  '/dev/gallery': typeof DevGalleryRoute
  '/invite/$token': typeof InviteTokenRoute
  '/org/$orgId/approvals': typeof OrgOrgIdApprovalsRoute
  '/org/$orgId/calendar': typeof OrgOrgIdCalendarRoute
  '/org/$orgId/drive': typeof OrgOrgIdDriveRoute
  '/org/$orgId/forum': typeof OrgOrgIdForumRoute
  '/org/$orgId/home': typeof OrgOrgIdHomeRoute
  '/org/$orgId/members': typeof OrgOrgIdMembersRoute
  '/org/$orgId/notifications': typeof OrgOrgIdNotificationsRoute
  '/org/$orgId/onboarding': typeof OrgOrgIdOnboardingRoute
  '/org/$orgId/proposals': typeof OrgOrgIdProposalsRoute
  '/org/$orgId/routines': typeof OrgOrgIdRoutinesRoute
  '/org/$orgId/search': typeof OrgOrgIdSearchRoute
  '/org/$orgId/settings': typeof OrgOrgIdSettingsRoute
  '/org/$orgId/task-manager': typeof OrgOrgIdTaskManagerRoute
  '/org/$orgId/team': typeof OrgOrgIdTeamRoute
  '/org/$orgId/wiki': typeof OrgOrgIdWikiRoute
  '/org/$orgId': typeof OrgOrgIdIndexRoute
  '/org/$orgId/agents/new': typeof OrgOrgIdAgentsNewRoute
  '/org/$orgId/c/$channelId': typeof OrgOrgIdCChannelIdRoute
  '/org/$orgId/forum/$topicId': typeof OrgOrgIdForumTopicIdRoute
  '/org/$orgId/issues/$number': typeof OrgOrgIdIssuesNumberRoute
  '/org/$orgId/settings/$section': typeof OrgOrgIdSettingsSectionRoute
  '/org/$orgId/threads/$threadId': typeof OrgOrgIdThreadsThreadIdRoute
  '/org/$orgId/wiki/$slug': typeof OrgOrgIdWikiSlugRoute
  '/org/$orgId/issues': typeof OrgOrgIdIssuesIndexRoute
  '/org/$orgId/threads': typeof OrgOrgIdThreadsIndexRoute
  '/org/$orgId/agents/$agentId/memory': typeof OrgOrgIdAgentsAgentIdMemoryRoute
  '/org/$orgId/dm/agent/$agentId': typeof OrgOrgIdDmAgentAgentIdRoute
  '/org/$orgId/dm/person/$userId': typeof OrgOrgIdDmPersonUserIdRoute
  '/org/$orgId/settings/computers/$machineId': typeof OrgOrgIdSettingsComputersMachineIdRoute
  '/org/$orgId/agents/$agentId': typeof OrgOrgIdAgentsAgentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/autorizar': typeof AutorizarRoute
  '/conectar': typeof ConectarRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/owner': typeof OwnerRoute
  '/privacidade': typeof PrivacidadeRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/termos': typeof TermosRoute
  '/terms': typeof TermsRoute
  '/desktop/connector': typeof DesktopConnectorRoute
  '/desktop/handover': typeof DesktopHandoverRoute
  '/desktop/sign-in': typeof DesktopSignInRoute
  '/desktop/signed-in': typeof DesktopSignedInRoute
  '/dev/gallery': typeof DevGalleryRoute
  '/invite/$token': typeof InviteTokenRoute
  '/org/$orgId': typeof OrgOrgIdRouteWithChildren
  '/org/$orgId/approvals': typeof OrgOrgIdApprovalsRoute
  '/org/$orgId/calendar': typeof OrgOrgIdCalendarRoute
  '/org/$orgId/drive': typeof OrgOrgIdDriveRoute
  '/org/$orgId/forum': typeof OrgOrgIdForumRoute
  '/org/$orgId/home': typeof OrgOrgIdHomeRoute
  '/org/$orgId/members': typeof OrgOrgIdMembersRoute
  '/org/$orgId/notifications': typeof OrgOrgIdNotificationsRoute
  '/org/$orgId/onboarding': typeof OrgOrgIdOnboardingRoute
  '/org/$orgId/proposals': typeof OrgOrgIdProposalsRoute
  '/org/$orgId/routines': typeof OrgOrgIdRoutinesRoute
  '/org/$orgId/search': typeof OrgOrgIdSearchRoute
  '/org/$orgId/settings': typeof OrgOrgIdSettingsRoute
  '/org/$orgId/task-manager': typeof OrgOrgIdTaskManagerRoute
  '/org/$orgId/team': typeof OrgOrgIdTeamRoute
  '/org/$orgId/wiki': typeof OrgOrgIdWikiRoute
  '/org/$orgId/': typeof OrgOrgIdIndexRoute
  '/org/$orgId/agents/new': typeof OrgOrgIdAgentsNewRoute
  '/org/$orgId/c/$channelId': typeof OrgOrgIdCChannelIdRoute
  '/org/$orgId/forum_/$topicId': typeof OrgOrgIdForumTopicIdRoute
  '/org/$orgId/issues/$number': typeof OrgOrgIdIssuesNumberRoute
  '/org/$orgId/settings_/$section': typeof OrgOrgIdSettingsSectionRoute
  '/org/$orgId/threads/$threadId': typeof OrgOrgIdThreadsThreadIdRoute
  '/org/$orgId/wiki_/$slug': typeof OrgOrgIdWikiSlugRoute
  '/org/$orgId/issues/': typeof OrgOrgIdIssuesIndexRoute
  '/org/$orgId/threads/': typeof OrgOrgIdThreadsIndexRoute
  '/org/$orgId/agents/$agentId/memory': typeof OrgOrgIdAgentsAgentIdMemoryRoute
  '/org/$orgId/dm/agent/$agentId': typeof OrgOrgIdDmAgentAgentIdRoute
  '/org/$orgId/dm/person/$userId': typeof OrgOrgIdDmPersonUserIdRoute
  '/org/$orgId/settings_/computers/$machineId': typeof OrgOrgIdSettingsComputersMachineIdRoute
  '/org/$orgId/agents/$agentId/': typeof OrgOrgIdAgentsAgentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/autorizar'
    | '/conectar'
    | '/login'
    | '/onboarding'
    | '/owner'
    | '/privacidade'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/termos'
    | '/terms'
    | '/desktop/connector'
    | '/desktop/handover'
    | '/desktop/sign-in'
    | '/desktop/signed-in'
    | '/dev/gallery'
    | '/invite/$token'
    | '/org/$orgId'
    | '/org/$orgId/approvals'
    | '/org/$orgId/calendar'
    | '/org/$orgId/drive'
    | '/org/$orgId/forum'
    | '/org/$orgId/home'
    | '/org/$orgId/members'
    | '/org/$orgId/notifications'
    | '/org/$orgId/onboarding'
    | '/org/$orgId/proposals'
    | '/org/$orgId/routines'
    | '/org/$orgId/search'
    | '/org/$orgId/settings'
    | '/org/$orgId/task-manager'
    | '/org/$orgId/team'
    | '/org/$orgId/wiki'
    | '/org/$orgId/'
    | '/org/$orgId/agents/new'
    | '/org/$orgId/c/$channelId'
    | '/org/$orgId/forum/$topicId'
    | '/org/$orgId/issues/$number'
    | '/org/$orgId/settings/$section'
    | '/org/$orgId/threads/$threadId'
    | '/org/$orgId/wiki/$slug'
    | '/org/$orgId/issues/'
    | '/org/$orgId/threads/'
    | '/org/$orgId/agents/$agentId/memory'
    | '/org/$orgId/dm/agent/$agentId'
    | '/org/$orgId/dm/person/$userId'
    | '/org/$orgId/settings/computers/$machineId'
    | '/org/$orgId/agents/$agentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/autorizar'
    | '/conectar'
    | '/login'
    | '/onboarding'
    | '/owner'
    | '/privacidade'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/termos'
    | '/terms'
    | '/desktop/connector'
    | '/desktop/handover'
    | '/desktop/sign-in'
    | '/desktop/signed-in'
    | '/dev/gallery'
    | '/invite/$token'
    | '/org/$orgId/approvals'
    | '/org/$orgId/calendar'
    | '/org/$orgId/drive'
    | '/org/$orgId/forum'
    | '/org/$orgId/home'
    | '/org/$orgId/members'
    | '/org/$orgId/notifications'
    | '/org/$orgId/onboarding'
    | '/org/$orgId/proposals'
    | '/org/$orgId/routines'
    | '/org/$orgId/search'
    | '/org/$orgId/settings'
    | '/org/$orgId/task-manager'
    | '/org/$orgId/team'
    | '/org/$orgId/wiki'
    | '/org/$orgId'
    | '/org/$orgId/agents/new'
    | '/org/$orgId/c/$channelId'
    | '/org/$orgId/forum/$topicId'
    | '/org/$orgId/issues/$number'
    | '/org/$orgId/settings/$section'
    | '/org/$orgId/threads/$threadId'
    | '/org/$orgId/wiki/$slug'
    | '/org/$orgId/issues'
    | '/org/$orgId/threads'
    | '/org/$orgId/agents/$agentId/memory'
    | '/org/$orgId/dm/agent/$agentId'
    | '/org/$orgId/dm/person/$userId'
    | '/org/$orgId/settings/computers/$machineId'
    | '/org/$orgId/agents/$agentId'
  id:
    | '__root__'
    | '/'
    | '/autorizar'
    | '/conectar'
    | '/login'
    | '/onboarding'
    | '/owner'
    | '/privacidade'
    | '/privacy'
    | '/reset-password'
    | '/signup'
    | '/termos'
    | '/terms'
    | '/desktop/connector'
    | '/desktop/handover'
    | '/desktop/sign-in'
    | '/desktop/signed-in'
    | '/dev/gallery'
    | '/invite/$token'
    | '/org/$orgId'
    | '/org/$orgId/approvals'
    | '/org/$orgId/calendar'
    | '/org/$orgId/drive'
    | '/org/$orgId/forum'
    | '/org/$orgId/home'
    | '/org/$orgId/members'
    | '/org/$orgId/notifications'
    | '/org/$orgId/onboarding'
    | '/org/$orgId/proposals'
    | '/org/$orgId/routines'
    | '/org/$orgId/search'
    | '/org/$orgId/settings'
    | '/org/$orgId/task-manager'
    | '/org/$orgId/team'
    | '/org/$orgId/wiki'
    | '/org/$orgId/'
    | '/org/$orgId/agents/new'
    | '/org/$orgId/c/$channelId'
    | '/org/$orgId/forum_/$topicId'
    | '/org/$orgId/issues/$number'
    | '/org/$orgId/settings_/$section'
    | '/org/$orgId/threads/$threadId'
    | '/org/$orgId/wiki_/$slug'
    | '/org/$orgId/issues/'
    | '/org/$orgId/threads/'
    | '/org/$orgId/agents/$agentId/memory'
    | '/org/$orgId/dm/agent/$agentId'
    | '/org/$orgId/dm/person/$userId'
    | '/org/$orgId/settings_/computers/$machineId'
    | '/org/$orgId/agents/$agentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AutorizarRoute: typeof AutorizarRoute
  ConectarRoute: typeof ConectarRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  OwnerRoute: typeof OwnerRoute
  PrivacidadeRoute: typeof PrivacidadeRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  TermosRoute: typeof TermosRoute
  TermsRoute: typeof TermsRoute
  DesktopConnectorRoute: typeof DesktopConnectorRoute
  DesktopHandoverRoute: typeof DesktopHandoverRoute
  DesktopSignInRoute: typeof DesktopSignInRoute
  DesktopSignedInRoute: typeof DesktopSignedInRoute
  DevGalleryRoute: typeof DevGalleryRoute
  InviteTokenRoute: typeof InviteTokenRoute
  OrgOrgIdRoute: typeof OrgOrgIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/autorizar': {
      id: '/autorizar'
      path: '/autorizar'
      fullPath: '/autorizar'
      preLoaderRoute: typeof AutorizarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conectar': {
      id: '/conectar'
      path: '/conectar'
      fullPath: '/conectar'
      preLoaderRoute: typeof ConectarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/owner': {
      id: '/owner'
      path: '/owner'
      fullPath: '/owner'
      preLoaderRoute: typeof OwnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacidade': {
      id: '/privacidade'
      path: '/privacidade'
      fullPath: '/privacidade'
      preLoaderRoute: typeof PrivacidadeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termos': {
      id: '/termos'
      path: '/termos'
      fullPath: '/termos'
      preLoaderRoute: typeof TermosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop/connector': {
      id: '/desktop/connector'
      path: '/desktop/connector'
      fullPath: '/desktop/connector'
      preLoaderRoute: typeof DesktopConnectorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop/handover': {
      id: '/desktop/handover'
      path: '/desktop/handover'
      fullPath: '/desktop/handover'
      preLoaderRoute: typeof DesktopHandoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop/sign-in': {
      id: '/desktop/sign-in'
      path: '/desktop/sign-in'
      fullPath: '/desktop/sign-in'
      preLoaderRoute: typeof DesktopSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/desktop/signed-in': {
      id: '/desktop/signed-in'
      path: '/desktop/signed-in'
      fullPath: '/desktop/signed-in'
      preLoaderRoute: typeof DesktopSignedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/gallery': {
      id: '/dev/gallery'
      path: '/dev/gallery'
      fullPath: '/dev/gallery'
      preLoaderRoute: typeof DevGalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId': {
      id: '/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof OrgOrgIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/$orgId/': {
      id: '/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof OrgOrgIdIndexRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/approvals': {
      id: '/org/$orgId/approvals'
      path: '/approvals'
      fullPath: '/org/$orgId/approvals'
      preLoaderRoute: typeof OrgOrgIdApprovalsRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/calendar': {
      id: '/org/$orgId/calendar'
      path: '/calendar'
      fullPath: '/org/$orgId/calendar'
      preLoaderRoute: typeof OrgOrgIdCalendarRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/drive': {
      id: '/org/$orgId/drive'
      path: '/drive'
      fullPath: '/org/$orgId/drive'
      preLoaderRoute: typeof OrgOrgIdDriveRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/forum': {
      id: '/org/$orgId/forum'
      path: '/forum'
      fullPath: '/org/$orgId/forum'
      preLoaderRoute: typeof OrgOrgIdForumRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/home': {
      id: '/org/$orgId/home'
      path: '/home'
      fullPath: '/org/$orgId/home'
      preLoaderRoute: typeof OrgOrgIdHomeRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/members': {
      id: '/org/$orgId/members'
      path: '/members'
      fullPath: '/org/$orgId/members'
      preLoaderRoute: typeof OrgOrgIdMembersRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/notifications': {
      id: '/org/$orgId/notifications'
      path: '/notifications'
      fullPath: '/org/$orgId/notifications'
      preLoaderRoute: typeof OrgOrgIdNotificationsRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/onboarding': {
      id: '/org/$orgId/onboarding'
      path: '/onboarding'
      fullPath: '/org/$orgId/onboarding'
      preLoaderRoute: typeof OrgOrgIdOnboardingRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/proposals': {
      id: '/org/$orgId/proposals'
      path: '/proposals'
      fullPath: '/org/$orgId/proposals'
      preLoaderRoute: typeof OrgOrgIdProposalsRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/routines': {
      id: '/org/$orgId/routines'
      path: '/routines'
      fullPath: '/org/$orgId/routines'
      preLoaderRoute: typeof OrgOrgIdRoutinesRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/search': {
      id: '/org/$orgId/search'
      path: '/search'
      fullPath: '/org/$orgId/search'
      preLoaderRoute: typeof OrgOrgIdSearchRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/settings': {
      id: '/org/$orgId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof OrgOrgIdSettingsRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/task-manager': {
      id: '/org/$orgId/task-manager'
      path: '/task-manager'
      fullPath: '/org/$orgId/task-manager'
      preLoaderRoute: typeof OrgOrgIdTaskManagerRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/team': {
      id: '/org/$orgId/team'
      path: '/team'
      fullPath: '/org/$orgId/team'
      preLoaderRoute: typeof OrgOrgIdTeamRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/wiki': {
      id: '/org/$orgId/wiki'
      path: '/wiki'
      fullPath: '/org/$orgId/wiki'
      preLoaderRoute: typeof OrgOrgIdWikiRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/agents/new': {
      id: '/org/$orgId/agents/new'
      path: '/agents/new'
      fullPath: '/org/$orgId/agents/new'
      preLoaderRoute: typeof OrgOrgIdAgentsNewRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/c/$channelId': {
      id: '/org/$orgId/c/$channelId'
      path: '/c/$channelId'
      fullPath: '/org/$orgId/c/$channelId'
      preLoaderRoute: typeof OrgOrgIdCChannelIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/forum_/$topicId': {
      id: '/org/$orgId/forum_/$topicId'
      path: '/forum/$topicId'
      fullPath: '/org/$orgId/forum/$topicId'
      preLoaderRoute: typeof OrgOrgIdForumTopicIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/issues/': {
      id: '/org/$orgId/issues/'
      path: '/issues'
      fullPath: '/org/$orgId/issues/'
      preLoaderRoute: typeof OrgOrgIdIssuesIndexRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/issues/$number': {
      id: '/org/$orgId/issues/$number'
      path: '/issues/$number'
      fullPath: '/org/$orgId/issues/$number'
      preLoaderRoute: typeof OrgOrgIdIssuesNumberRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/settings_/$section': {
      id: '/org/$orgId/settings_/$section'
      path: '/settings/$section'
      fullPath: '/org/$orgId/settings/$section'
      preLoaderRoute: typeof OrgOrgIdSettingsSectionRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/threads/': {
      id: '/org/$orgId/threads/'
      path: '/threads'
      fullPath: '/org/$orgId/threads/'
      preLoaderRoute: typeof OrgOrgIdThreadsIndexRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/threads/$threadId': {
      id: '/org/$orgId/threads/$threadId'
      path: '/threads/$threadId'
      fullPath: '/org/$orgId/threads/$threadId'
      preLoaderRoute: typeof OrgOrgIdThreadsThreadIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/wiki_/$slug': {
      id: '/org/$orgId/wiki_/$slug'
      path: '/wiki/$slug'
      fullPath: '/org/$orgId/wiki/$slug'
      preLoaderRoute: typeof OrgOrgIdWikiSlugRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/agents/$agentId/': {
      id: '/org/$orgId/agents/$agentId/'
      path: '/agents/$agentId'
      fullPath: '/org/$orgId/agents/$agentId/'
      preLoaderRoute: typeof OrgOrgIdAgentsAgentIdIndexRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/agents/$agentId/memory': {
      id: '/org/$orgId/agents/$agentId/memory'
      path: '/agents/$agentId/memory'
      fullPath: '/org/$orgId/agents/$agentId/memory'
      preLoaderRoute: typeof OrgOrgIdAgentsAgentIdMemoryRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/dm/agent/$agentId': {
      id: '/org/$orgId/dm/agent/$agentId'
      path: '/dm/agent/$agentId'
      fullPath: '/org/$orgId/dm/agent/$agentId'
      preLoaderRoute: typeof OrgOrgIdDmAgentAgentIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/dm/person/$userId': {
      id: '/org/$orgId/dm/person/$userId'
      path: '/dm/person/$userId'
      fullPath: '/org/$orgId/dm/person/$userId'
      preLoaderRoute: typeof OrgOrgIdDmPersonUserIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
    '/org/$orgId/settings_/computers/$machineId': {
      id: '/org/$orgId/settings_/computers/$machineId'
      path: '/settings/computers/$machineId'
      fullPath: '/org/$orgId/settings/computers/$machineId'
      preLoaderRoute: typeof OrgOrgIdSettingsComputersMachineIdRouteImport
      parentRoute: typeof OrgOrgIdRoute
    }
  }
}

interface OrgOrgIdRouteChildren {
  OrgOrgIdApprovalsRoute: typeof OrgOrgIdApprovalsRoute
  OrgOrgIdCalendarRoute: typeof OrgOrgIdCalendarRoute
  OrgOrgIdDriveRoute: typeof OrgOrgIdDriveRoute
  OrgOrgIdForumRoute: typeof OrgOrgIdForumRoute
  OrgOrgIdHomeRoute: typeof OrgOrgIdHomeRoute
  OrgOrgIdMembersRoute: typeof OrgOrgIdMembersRoute
  OrgOrgIdNotificationsRoute: typeof OrgOrgIdNotificationsRoute
  OrgOrgIdOnboardingRoute: typeof OrgOrgIdOnboardingRoute
  OrgOrgIdProposalsRoute: typeof OrgOrgIdProposalsRoute
  OrgOrgIdRoutinesRoute: typeof OrgOrgIdRoutinesRoute
  OrgOrgIdSearchRoute: typeof OrgOrgIdSearchRoute
  OrgOrgIdSettingsRoute: typeof OrgOrgIdSettingsRoute
  OrgOrgIdTaskManagerRoute: typeof OrgOrgIdTaskManagerRoute
  OrgOrgIdTeamRoute: typeof OrgOrgIdTeamRoute
  OrgOrgIdWikiRoute: typeof OrgOrgIdWikiRoute
  OrgOrgIdIndexRoute: typeof OrgOrgIdIndexRoute
  OrgOrgIdAgentsNewRoute: typeof OrgOrgIdAgentsNewRoute
  OrgOrgIdCChannelIdRoute: typeof OrgOrgIdCChannelIdRoute
  OrgOrgIdForumTopicIdRoute: typeof OrgOrgIdForumTopicIdRoute
  OrgOrgIdIssuesNumberRoute: typeof OrgOrgIdIssuesNumberRoute
  OrgOrgIdSettingsSectionRoute: typeof OrgOrgIdSettingsSectionRoute
  OrgOrgIdThreadsThreadIdRoute: typeof OrgOrgIdThreadsThreadIdRoute
  OrgOrgIdWikiSlugRoute: typeof OrgOrgIdWikiSlugRoute
  OrgOrgIdIssuesIndexRoute: typeof OrgOrgIdIssuesIndexRoute
  OrgOrgIdThreadsIndexRoute: typeof OrgOrgIdThreadsIndexRoute
  OrgOrgIdAgentsAgentIdMemoryRoute: typeof OrgOrgIdAgentsAgentIdMemoryRoute
  OrgOrgIdDmAgentAgentIdRoute: typeof OrgOrgIdDmAgentAgentIdRoute
  OrgOrgIdDmPersonUserIdRoute: typeof OrgOrgIdDmPersonUserIdRoute
  OrgOrgIdSettingsComputersMachineIdRoute: typeof OrgOrgIdSettingsComputersMachineIdRoute
  OrgOrgIdAgentsAgentIdIndexRoute: typeof OrgOrgIdAgentsAgentIdIndexRoute
}

const OrgOrgIdRouteChildren: OrgOrgIdRouteChildren = {
  OrgOrgIdApprovalsRoute: OrgOrgIdApprovalsRoute,
  OrgOrgIdCalendarRoute: OrgOrgIdCalendarRoute,
  OrgOrgIdDriveRoute: OrgOrgIdDriveRoute,
  OrgOrgIdForumRoute: OrgOrgIdForumRoute,
  OrgOrgIdHomeRoute: OrgOrgIdHomeRoute,
  OrgOrgIdMembersRoute: OrgOrgIdMembersRoute,
  OrgOrgIdNotificationsRoute: OrgOrgIdNotificationsRoute,
  OrgOrgIdOnboardingRoute: OrgOrgIdOnboardingRoute,
  OrgOrgIdProposalsRoute: OrgOrgIdProposalsRoute,
  OrgOrgIdRoutinesRoute: OrgOrgIdRoutinesRoute,
  OrgOrgIdSearchRoute: OrgOrgIdSearchRoute,
  OrgOrgIdSettingsRoute: OrgOrgIdSettingsRoute,
  OrgOrgIdTaskManagerRoute: OrgOrgIdTaskManagerRoute,
  OrgOrgIdTeamRoute: OrgOrgIdTeamRoute,
  OrgOrgIdWikiRoute: OrgOrgIdWikiRoute,
  OrgOrgIdIndexRoute: OrgOrgIdIndexRoute,
  OrgOrgIdAgentsNewRoute: OrgOrgIdAgentsNewRoute,
  OrgOrgIdCChannelIdRoute: OrgOrgIdCChannelIdRoute,
  OrgOrgIdForumTopicIdRoute: OrgOrgIdForumTopicIdRoute,
  OrgOrgIdIssuesNumberRoute: OrgOrgIdIssuesNumberRoute,
  OrgOrgIdSettingsSectionRoute: OrgOrgIdSettingsSectionRoute,
  OrgOrgIdThreadsThreadIdRoute: OrgOrgIdThreadsThreadIdRoute,
  OrgOrgIdWikiSlugRoute: OrgOrgIdWikiSlugRoute,
  OrgOrgIdIssuesIndexRoute: OrgOrgIdIssuesIndexRoute,
  OrgOrgIdThreadsIndexRoute: OrgOrgIdThreadsIndexRoute,
  OrgOrgIdAgentsAgentIdMemoryRoute: OrgOrgIdAgentsAgentIdMemoryRoute,
  OrgOrgIdDmAgentAgentIdRoute: OrgOrgIdDmAgentAgentIdRoute,
  OrgOrgIdDmPersonUserIdRoute: OrgOrgIdDmPersonUserIdRoute,
  OrgOrgIdSettingsComputersMachineIdRoute:
    OrgOrgIdSettingsComputersMachineIdRoute,
  OrgOrgIdAgentsAgentIdIndexRoute: OrgOrgIdAgentsAgentIdIndexRoute,
}

const OrgOrgIdRouteWithChildren = OrgOrgIdRoute._addFileChildren(
  OrgOrgIdRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AutorizarRoute: AutorizarRoute,
  ConectarRoute: ConectarRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  OwnerRoute: OwnerRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  TermosRoute: TermosRoute,
  TermsRoute: TermsRoute,
  DesktopConnectorRoute: DesktopConnectorRoute,
  DesktopHandoverRoute: DesktopHandoverRoute,
  DesktopSignInRoute: DesktopSignInRoute,
  DesktopSignedInRoute: DesktopSignedInRoute,
  DevGalleryRoute: DevGalleryRoute,
  InviteTokenRoute: InviteTokenRoute,
  OrgOrgIdRoute: OrgOrgIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
